import { useQuery } from '@tanstack/react-query'
import { IRequestSetUser, IResponseLogin } from 'auth/models'
import { TQueryOptions } from 'common/models'
import { api } from 'services'

import { ApiKeysEnum } from './apiKeys'

const setUser = async ({ clientId, applicationId, siteId }: IRequestSetUser) => {
  const { data } = await api.post<IResponseLogin>(
    `client/user/client/${clientId}/application/${applicationId}/site/${siteId}/set`,
  )

  return data
}

export default function useSetUserQuery(
  { clientId, applicationId, siteId }: IRequestSetUser,
  options: TQueryOptions<IResponseLogin> = {},
) {
  return useQuery({
    queryKey: [ApiKeysEnum.SET_USER, clientId, applicationId, siteId],
    queryFn: () => setUser({ clientId, applicationId, siteId }),
    ...options,
  })
}
